<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-map-marker"
    ></vuse-section-definition>
    <v-container fluid class="content_product1">
      <v-row justify="center" align="center">
        <v-col cols="12" align="right">
          <v-btn
              color="primary"
              align="right"
              @click="addNew"
          >
            Thêm showroom
          </v-btn>
        </v-col>
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="showrooms"
              :items-per-page="10"
              class="elevation-1"
          >

            <template v-slot:item.hotline="{ item }" >
              <span class="red--text">{{item.hotline}}</span>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small class="mr-2" @click="reviewItem(item)">
                mdi-eye
              </v-icon>
              <v-icon small @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {GET_LIST_SHOWROOM, DELETE_SHOWROOM} from '@/store/modules/showroom';
import {mapGetters} from 'vuex';
export default {
  data() {
    return {
      page: "Quản lý showroom",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Quản lý showroom",
          disabled: true,
        },
        {
          text: "Danh sách showroom",
          disabled: true,
        },
      ],
      items:[
        {
          id:1,
          name: 'TGB Nam Dương tầng 3, TT TM The Garden Mễ Trì',
          area: 'Hà Nội',
          address: 'Lorem ipsum dolor sit .Lorem ipsum dolor sit amet, tetur adipiscing elit...',
          hotline: '0981.966.899',
        },
        {
          id:2,
          name: 'TGB Nam Dương tầng 3, TT TM The Garden Mễ Trì',
          area: 'Hà Nội',
          address: 'Lorem ipsum dolor sit .Lorem ipsum dolor sit amet, tetur adipiscing elit...',
          hotline: '0981.966.899',
        },
        {
          id:3,
          name: 'TGB Nam Dương tầng 3, TT TM The Garden Mễ Trì',
          area: 'Hà Nội',
          address: 'Lorem ipsum dolor sit .Lorem ipsum dolor sit amet, tetur adipiscing elit...',
          hotline: '0981.966.899',
        },
        {
          id:4,
          name: 'TGB Nam Dương tầng 3, TT TM The Garden Mễ Trì',
          area: 'Hà Nội',
          address: 'Lorem ipsum dolor sit .Lorem ipsum dolor sit amet, tetur adipiscing elit...',
          hotline: '0981.966.899',
        },
      ],
      headers: [
        { text: 'ID', value: 'id', align: 'start', },
        {
          text: 'Tên showrrom',
          sortable: false,
          value: 'name',
        },
        { text: 'Khu vực', value: 'area_name' },
        { text: 'Địa chỉ', value: 'address' },
        { text: 'Hotline', value: 'hotline' },
        { text: 'Actions', value: 'actions' },
      ],
    };
  },
  computed:{
    ...mapGetters({
      showrooms: 'showrooms',
    })
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_SHOWROOM}`);
  },

  methods:{
    editItem(id){
      this.$router.push({
        path:'/show_room/edit_showroom/'+id,
      })
    },
    reviewItem() {

    },
    deleteItem(item){
      confirm('Bạn có chắc muốn xóa?') &&
      this.$store.dispatch(`${DELETE_SHOWROOM}`,item.id).then(data=>{
        if(data && data.status === 1) {
          this.$store.dispatch(GET_LIST_SHOWROOM);
        }
      })
    },
    addNew() {
      this.$router.push('/show_room/add_showroom')
    }
  }
};
</script>
<style lang="scss">
.content_product1 {
  background: #ffffff !important;
}
</style>
